import React, { useRef, useEffect, useState, useCallback } from "react";
import api from "../../services/api";

import errors, { IAliancaErrors } from "../../Utils/ExtractErrors";

import { Form, Modal, Button, Grid, Image, Loader, Dimmer, Label, Input, DropdownProps, TextAreaProps, Divider, Segment, InputProps, InputOnChangeData } from "semantic-ui-react";
import { toast } from "react-toastify";

import ModalApp from "../../components/ModalApp";
import ImageZoom from "../../components/ImageZoom";
import ModalYesNo from "../../components/ModalYesNo";

import { IEntradas, IImagem } from "../../interfaces";
import { GetUser } from "../../services/auth";
import CustomLoader from "../../components/CustomLoader";
import AgentsRepository, { IAgentListModel } from "../../Repositories/AgentsRepository";
import RegionalManagerRepository, { IRegionalManagerListModel } from "../../Repositories/RegionalManagerRepository";
import SectorManagerRepository, { ISectorManagerListModel } from "../../Repositories/SectorManagerRepository";
import PaymentsRepository from "../../Repositories/PaymentsRepository";
import MaskedInput from "../../components/MaskedInput";
import NumberFormat from "../../Utils/NumberFormat";

interface State extends IEntradas {
    images: IImagem[];
    apiErrors: IAliancaErrors;
}

interface Props {
    onSuccess: () => void;
}

const initialState: State = {
    id: "",
    data: "",
    dataComprovante: "",
    gerenteRegionalId: "",
    gerenteSetorId: "",
    representanteId: "",
    valorEntrada: "",
    observacao: "",
    numeroComprovante: "",
    images: [],
    apiErrors: { errors: [] }
}

const DetalharEntrada: React.FC<Props> = (props) => {

    const [open, setOpen] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [state, setState] = useState<State>(initialState);
    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
    const [preview, setPreview] = useState<string[]>([]);

    const [regionalManagers, setRegionalManagers] = useState<IRegionalManagerListModel[]>([]);
    const [sectorManagers, setSectorManagers] = useState<ISectorManagerListModel[]>([]);
    const [agents, setAgents] = useState<IAgentListModel[]>([]);

    const [valorEntrada, setValorEntrada] = useState<string>("");

    const fileInputRef = useRef<HTMLInputElement>(null);

    const { role, refId } = GetUser();

    const onButtonClick = () => {
        if (fileInputRef && fileInputRef.current) {
            fileInputRef.current.click();
        }
    }

    useEffect(() => {
        if (selectedFiles.length > 0) {
            let images: string[] = [];

            for (const file of selectedFiles) {
                images.push(URL.createObjectURL(file));
            }

            setPreview(preview => preview.concat(images));

            return () => {
                for (const image of images) { URL.revokeObjectURL(image) }
                setPreview([]);
            }
        }
    }, [selectedFiles]);

    const handleOpen = () => {
        setOpen(true);
    }

    const handleClose = () => {
        setState(initialState);
        setOpen(false);
        setSelectedFiles([]);
        setPreview([]);
    }

    const LoadRegionalManagers = useCallback(async () => {
        const result = await RegionalManagerRepository.List({
            filter: "Status == 1"
        });

        setRegionalManagers(result.list);
    }, []);

    useEffect(() => { LoadRegionalManagers() }, [LoadRegionalManagers]);

    const LoadSectorManagers = useCallback(async (id: string) => {
        const result = await SectorManagerRepository.List({
            filter: `GerenteRegionalId == "${id}" && Status == 1`
        });

        setSectorManagers(result.list);
    }, []);

    const LoadAgents = useCallback(async (id: string) => {
        const result = await AgentsRepository.List({
            filter: `GerenteSetorId == "${id}"`
        });

        setAgents(result.list);
    }, []);

    const onRegionalManagerChange = (event: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
        const { name, value } = data;

        setState({ ...state, [name]: value, gerenteSetorId: "", representanteId: "" });

        LoadSectorManagers(value?.toString() || "");
    }

    const onSectorManagerChange = (event: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
        const { name, value } = data;

        setState({ ...state, [name]: value, representanteId: "" });

        LoadAgents(value?.toString() || "");
    }

    const onAgentChange = (event: React.SyntheticEvent<HTMLElement, Event>, data: DropdownProps) => {
        const { name, value } = data;

        setState({ ...state, [name]: value });
    }

    const onChange = (event: React.SyntheticEvent<HTMLElement, Event>, data: InputProps) => {
        const { name, value } = data;

        setState({ ...state, [name]: value });
    }

    const onSelectFile = (e: any) => {
        if (!e.target.files || e.target.files.length === 0) {
            setSelectedFiles([])
            return

        }

        let files: File[] = [];
        files = files.concat(selectedFiles);

        for (const file of e.target.files) {
            files.push(file);
        }

        setSelectedFiles(files);
    }

    const onRemovePreview = (imageUrl: string, index: number) => {
        const images = preview.filter(x => x !== imageUrl);

        selectedFiles.splice(index, 1);

        URL.revokeObjectURL(imageUrl);
        setPreview(images);
    }

    const handleOnChangeValorEntrada = (event: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
        setValorEntrada(data.value);
    }

    const handleSubmitForm = async () => {
        if (selectedFiles.length >= 0) {
            try {
                setLoading(true);
                const data = new FormData();
                const valorFormatado = valorEntrada.toString();
                data.append("dataComprovante", state.dataComprovante);
                data.append("gerenteRegionalId", state.gerenteRegionalId);
                data.append("gerenteSetorId", state.gerenteSetorId);
                data.append("representanteId", state.representanteId);
                data.append("valorEntrada", valorFormatado);
                data.append("observacao", state.observacao);
                data.append("numeroComprovante", state.numeroComprovante);

                for (const file of selectedFiles) {
                    data.append("files", file);
                }

                const response = await PaymentsRepository.Insert(data);

                setState(initialState);
                setSelectedFiles([]);
                setPreview([]);

                toast(`🎉 ${response.message}`, { position: "top-center", type: "success" });
                setOpen(false);
                props.onSuccess();

            } catch (err) {
                if (err.response.status === 401) {
                    window.location.href = "/";
                }

                setState({ ...state, apiErrors: err.response.data });

                const error = errors.getApiErrors(state.apiErrors);

                if (error !== undefined)
                    toast(error, { position: "top-center", type: "error" });
            }
            setLoading(false);
        } else {
            toast("❌ É necessário inserir no mínimo 1 foto.", { position: "top-center", type: "error" });
        }
    }

    const cadastrarContent = (
        <Modal.Content scrolling>
            {loading &&
                <CustomLoader />}
            {!loading &&
                <>
                    <Grid.Column>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <Form.Dropdown
                                        fluid
                                        selection
                                        search
                                        scrolling
                                        required
                                        name="gerenteRegionalId"
                                        noResultsMessage="Nenhum registro encontrado."
                                        placeholder="Selecione"
                                        label="G. Regional"
                                        value={state.gerenteRegionalId}
                                        onChange={onRegionalManagerChange}
                                        options={regionalManagers.map(regionalManager => { return { key: regionalManager.id, value: regionalManager.id, text: regionalManager.nome } })}
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <Form.Dropdown
                                        fluid
                                        selection
                                        search
                                        scrolling
                                        required
                                        disabled={state.gerenteRegionalId.length === 0}
                                        name="gerenteSetorId"
                                        noResultsMessage="Nenhum registro encontrado."
                                        placeholder="Selecione"
                                        label="G. Setor"
                                        value={state.gerenteSetorId}
                                        onChange={onSectorManagerChange}
                                        options={sectorManagers.map(sectorManager => { return { key: sectorManager.id, value: sectorManager.id, text: sectorManager.nome } })}
                                    />
                                </Form.Field>
                                <Form.Field>
                                    <Form.Dropdown
                                        fluid
                                        selection
                                        search
                                        scrolling
                                        required
                                        disabled={(state.gerenteSetorId?.length || "") === ""}
                                        name="representanteId"
                                        noResultsMessage="Nenhum registro encontrado."
                                        placeholder="Selecione"
                                        label="Representante"
                                        value={state.representanteId}
                                        onChange={onAgentChange}
                                        options={agents.map(agent => { return { key: agent.id, value: agent.id, text: agent.nome } })}
                                    />
                                </Form.Field>
                            </Form.Group>
                            <Grid.Row>
                                <Grid.Column>
                                    <Form.Group widths="equal">
                                        <Form.Field required>
                                            <label>Nº Comprovante</label>
                                            <Input
                                                icon="file text"
                                                fluid
                                                iconPosition="left"
                                                placeholder="Número"
                                                name="numeroComprovante"
                                                value={state.numeroComprovante}
                                                onChange={onChange}
                                            />
                                        </Form.Field>
                                        <Form.Field required>
                                            <label>Data do Comprovante</label>
                                            <MaskedInput
                                                fluid
                                                mask="data"
                                                name="dataComprovante"
                                                icon="calendar alternate"
                                                iconPosition="left"
                                                placeholder="Data Comprovante"
                                                value={state.dataComprovante}
                                                onChange={onChange}
                                            />
                                        </Form.Field>
                                        <Form.Field required>
                                            <label>Valor da Entrada</label>
                                            <MaskedInput
                                                fluid
                                                mask="currency"
                                                label="R$"
                                                placeholder="Valor da entrada"
                                                value={valorEntrada}
                                                onChange={handleOnChangeValorEntrada}
                                            />
                                        </Form.Field>
                                    </Form.Group>
                                </Grid.Column>
                                <Grid.Column>
                                    <Form.Field>
                                        <label>Observação</label>
                                        <Input
                                            label="Observação"
                                            fluid
                                            placeholder="Observação ..."
                                            name="observacao"
                                            value={state.observacao}
                                            onChange={onChange}
                                        />
                                    </Form.Field>
                                </Grid.Column>
                            </Grid.Row>
                            <Divider></Divider>
                            <Grid.Row>
                                <Form.Field>
                                    <Button
                                        content="Anexar comprovante (opcional)"
                                        icon="images"
                                        fluid
                                        onClick={onButtonClick}
                                        color="black"
                                    />
                                    <input
                                        ref={fileInputRef}
                                        type="file"
                                        name="files"
                                        hidden
                                        multiple
                                        accept="image/*"
                                        onChange={onSelectFile}
                                    />
                                </Form.Field>
                            </Grid.Row>
                            {
                                preview.length > 0 &&
                                <>
                                    <Divider />
                                    <Segment placeholder>
                                        <Grid columns={1} stackable>
                                            <Grid.Row>
                                                <Grid.Column>
                                                    <Grid columns={4} doubling textAlign="center">
                                                        {preview.length > 0 &&
                                                            preview.map((x, index) =>
                                                                <Grid.Column key={`image-${index}`}>
                                                                    <Image
                                                                        fluid
                                                                        label={<ImageZoom imagePath={x} />}
                                                                        src={x}
                                                                    />
                                                                    <ModalYesNo
                                                                        trigger={<Button icon="trash" color="red" attached="bottom" />}
                                                                        header="Apagar"
                                                                        content="Deseja realmente apagar esta foto?"
                                                                        onSuccess={() => onRemovePreview(x, index)}
                                                                    />
                                                                </Grid.Column>
                                                            )}
                                                    </Grid>
                                                </Grid.Column>
                                            </Grid.Row>
                                        </Grid>
                                    </Segment>
                                </>
                            }
                        </Form>
                    </Grid.Column>

                </>
            }


        </Modal.Content >
    );

    return (
        <ModalApp
            open={open}
            handleOpen={handleOpen}
            handleClose={handleClose}
            title="Lançar Entrada"
            content={cadastrarContent}
            trigger={{
                icon: "add",
                color: "pink",
                content: "Lançar Entrada",
                labelPosition: "left",
                floated: "right"
            }}
            onSuccess={{ content: "Salvar", func: handleSubmitForm }}
        />
    );
};

export default DetalharEntrada;
